import { IEngagementContext } from './types';

const MS_PER_MINUTE = 60_000;

interface IBuildEngagementContextArgs {
  /** When the office landed in the portal (proxy for the email click). */
  clickedAt: Date;
  /** Shift start time, when the landing page is scoped to a single shift. */
  shiftStartAt?: Date | string | number | null;
}

/**
 * Derives the engagement-timing payload shared by every office-notification
 * event. Pure: the shift-start delta is added only when a valid shift start is
 * supplied (single-shift CTAs), and omitted otherwise. Hour/day-of-week are
 * intentionally not derived — PostHog's `$timestamp` covers them (GOTU-4135).
 */
export function buildEngagementContext({
  clickedAt,
  shiftStartAt,
}: IBuildEngagementContextArgs): IEngagementContext {
  const context: IEngagementContext = {};

  if (shiftStartAt !== undefined && shiftStartAt !== null) {
    const shiftStart = shiftStartAt instanceof Date ? shiftStartAt : new Date(shiftStartAt);
    const shiftStartMs = shiftStart.getTime();

    if (!Number.isNaN(shiftStartMs)) {
      context.time_to_shift_start_minutes = Math.round(
        (shiftStartMs - clickedAt.getTime()) / MS_PER_MINUTE,
      );
    }
  }

  return context;
}
